import { Link } from "react-router-dom";
import { Medal, Trash2, Users } from "lucide-react";
import { UserAvatar, UserLink } from "@/components/UserBits";
import { timeAgo } from "@/lib/timeAgo";

const RING = ["from-yellow-200 to-amber-500", "from-slate-100 to-slate-400", "from-orange-200 to-orange-500"];
const ORDER = [1, 0, 2];

export const CommunityHeader = ({ p, onDelete }) => (
  <div className="flex items-center gap-2 sm:gap-3" data-testid={`community-post-header-${p.id}`}>
    <div className="w-9 h-9 sm:w-11 sm:h-11 rounded-full bg-gradient-to-br from-amber-300 to-rose-500 text-white flex items-center justify-center shadow"><Users className="w-5 h-5" /></div>
    <div className="min-w-0 flex-1">
      <p className="font-semibold text-sm">Community-Meldung</p>
      <p className="text-xs text-slate-400">{timeAgo(p.created_at)}</p>
    </div>
    {p.can_delete && <button onClick={onDelete} data-testid={`post-delete-${p.id}`} title="Löschen" className="p-2 rounded-full text-slate-300 hover:text-red-600 hover:bg-red-50"><Trash2 className="w-4 h-4" /></button>}
  </div>
);

export function QuestHeroesPost({ g }) {
  const top = ORDER.map((i) => g.heroes[i]).filter(Boolean);
  return (
    <div className="relative overflow-hidden rounded-3xl bg-gradient-to-b from-amber-50 via-yellow-50 to-white p-5 border-2 border-amber-300 shadow-lg shadow-amber-100" data-testid="quest-heroes-post">
      <div className="gold-banner absolute inset-x-0 top-0 h-1.5" aria-hidden />
      <p className="text-center text-[11px] font-extrabold uppercase tracking-[0.3em] text-amber-600 flex items-center justify-center gap-1.5"><Medal className="w-3.5 h-3.5" /> Aufgaben-Helden</p>
      <h3 className="text-center font-display text-2xl font-black text-slate-900 mt-1">„{g.title}“ geschafft!</h3>
      <p className="text-center text-sm text-slate-500 mt-1">Danke an alle {g.participants} Mitmacher – diese drei haben am meisten geholfen:</p>
      <div className="mt-5 flex items-end justify-center gap-3 sm:gap-6">
        {top.map((h) => (
          <div key={h.user_id} className={`flex flex-col items-center text-center gap-1.5 w-24 ${h.rank === 1 ? "" : "pt-5"}`} data-testid={`quest-heroes-post-${h.rank}`}>
            <div className={`relative p-1 rounded-full bg-gradient-to-br ${RING[h.rank - 1]}`}>
              <UserLink id={h.user_id}><UserAvatar userId={h.user_id} name={h.name} picture={h.picture} size={h.rank === 1 ? "w-20 h-20" : "w-14 h-14"} /></UserLink>
              <span className={`absolute -bottom-1 left-1/2 -translate-x-1/2 w-7 h-7 rounded-full bg-gradient-to-br ${RING[h.rank - 1]} text-xs font-black text-slate-900 flex items-center justify-center border-2 border-white`}>{h.rank}</span>
            </div>
            <UserLink id={h.user_id} className="mt-1 text-sm font-bold truncate max-w-full">{h.name}</UserLink>
            <span className="text-xs font-semibold text-amber-700">{h.total} Beiträge</span>
          </div>
        ))}
      </div>
      <Link to="/community-aufgabe" data-testid="quest-heroes-post-link" className="mt-5 block text-center text-xs font-bold text-amber-700 hover:underline">Zur Community-Aufgabe →</Link>
    </div>
  );
}
